// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/mountain-flying.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/mountain-flying/mountain-flying.js';

mount([g0]);
